import React from "react";
import RegistrationWizardState from "../registrationWizardState";

const MAX_PHOTO_SIZE = 5 * 1024 * 1024;
const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];

class WelcomeStep extends React.Component {
  state = { photoError: "" };
  fileInputRef = React.createRef();

  getInitials = () => {
    const d = RegistrationWizardState.getStepData();
    const first = d.firstName.value?.[0] || "";
    const last = d.lastName.value?.[0] || "";
    return (first + last).toUpperCase() || "?";
  };

  onPhotoSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      this.setState({ photoError: "Please upload a PNG or JPG image." });
      return;
    }
    if (file.size > MAX_PHOTO_SIZE) {
      this.setState({ photoError: "Image must be 5 MB or smaller." });
      return;
    }

    this.setState({ photoError: "" });
    const reader = new FileReader();
    reader.onload = () => {
      RegistrationWizardState.updateField("photo", { file, dataUrl: reader.result });
    };
    reader.readAsDataURL(file);
  };

  render() {
    const { showValidation } = this.props;
    const d = RegistrationWizardState.getStepData();
    const photo = d.photo.value;
    const photoSrc = photo?.dataUrl;
    const { photoError } = this.state;

    return (
      <div>
        <h2 className="clinician-onboard-title">Your profile</h2>
        <p className="clinician-onboard-subtitle">
          Add your name and photo so patients and colleagues can recognize you.
        </p>

        <div className="clinician-onboard-avatar-section">
          <div className="clinician-onboard-avatar">
            {photoSrc ? <img src={photoSrc} alt="" /> : this.getInitials()}
          </div>
          <input
            ref={this.fileInputRef}
            type="file"
            accept="image/png,image/jpeg"
            style={{ display: "none" }}
            onChange={this.onPhotoSelect}
          />
          <button
            type="button"
            className="clinician-onboard-upload-btn"
            onClick={() => this.fileInputRef.current?.click()}
          >
            Upload photo
          </button>
          <p className="clinician-onboard-field-hint">PNG or JPG, max 5 MB</p>
          {photoError && (
            <p className="clinician-onboard-field-error" role="alert">
              {photoError}
            </p>
          )}
        </div>

        <div className="clinician-onboard-field">
          <label>
            First name <span className="required">*</span>
          </label>
          <input
            className={`clinician-onboard-input ${
              showValidation && !d.firstName.value.trim() ? "invalid" : ""
            }`}
            value={d.firstName.value}
            onChange={(e) => RegistrationWizardState.updateField("firstName", e.target.value)}
            placeholder="Enter your first name"
          />
        </div>

        <div className="clinician-onboard-field">
          <label>
            Last name <span className="required">*</span>
          </label>
          <input
            className={`clinician-onboard-input ${
              showValidation && !d.lastName.value.trim() ? "invalid" : ""
            }`}
            value={d.lastName.value}
            onChange={(e) => RegistrationWizardState.updateField("lastName", e.target.value)}
            placeholder="Enter your last name"
          />
        </div>
      </div>
    );
  }
}

export default WelcomeStep;
